import { render, staticRenderFns } from "./layout-confirm.vue?vue&type=template&id=7b50355c&"
import script from "./layout-confirm.vue?vue&type=script&lang=js&"
export * from "./layout-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports